import React from 'react';

import StartTradingFtr from '@appComponents/bb-startTradingFooter';
import { CoinsList } from '@appComponents/bb-coinlistView';
import SEO from '@components/SEO';

const titleText = 'Platform Guide to Trade Cryptocurrencies on Bitbns';
const description =
	'Get Started with Bitbns. Use the instructions to trade cryptocurrencies on bitbns. Check out how to purchase bitcoin.';
const url = 'https://bitbns.com/how-it-works/';

const HowItWorks = () => (
	<>
		<SEO title={titleText} description={description} url={url} />

		<div className="bg-primary text-white py-8">
			<div className="container">
				<h1 className="font-bold text-center my-0 text-3xl">
					How it works?
				</h1>
			</div>
		</div>
		<div className="bg-white py-8 px-4">
			<div className="container pt-8 pb-16">
				<div className="mx-auto u-para--readable">
					<ol className="ol--circleNumbered">
						<li className="ol__li mb-4">
							<h3 className="text-lg font-bold m-0">Sign up</h3>
							<ol className="list-decimal ml-6 u-para--readable ol--nostyle">
								<li className="mb-4">
									Click on sign up button
								</li>
								<li className="mb-4">
									Fill up the basic details shown on the
									screen
								</li>
								<li className="mb-4">
									Click next and enter the OTP received on
									your mobile number
								</li>
								<li className="mb-4">
									Click next, where you will be taken to KYC
									verification Screen
								</li>
							</ol>
						</li>
						<li className="ol__li mb-4">
							<h3 className="text-lg font-bold m-0">
								KYC verification
							</h3>
							<p className="u-para--readable my-4">
								You are to submit your National ID documents
								containing your address proof and your date of
								birth
							</p>
							<ol className="list-circle ml-6 l--circleChecked">
								<li className="mb-4">
									National document such as Aadhaar Card,
									Passport, PAN Card, Voter ID etc.
								</li>
								<li className="mb-4">
									Indian Citizens must enter your PAN card
									details
								</li>
								<li className="mb-4">
									Non-Indian Citizens can enter your National
									ID details containing date of birth
								</li>
							</ol>
							<p className="u-para--readable my-4">
								<a
									href="https://bitbns.com/trade/#/verify"
									className="c-links font-bold c-links--iconTri tri-right"
								>
									Complete your KYC Now
								</a>
							</p>
						</li>
						<li className="ol__li mb-4">
							<h3 className="text-lg font-bold m-0">Trading</h3>
							<p className="u-para--readable my-4">
								Upon completing the KYC Process, you will be
								taken to the dashboard where you will be able to
								trade cryptocurrencies
							</p>
							<ol className="ol--circleNumbered ol--circleChecked">
								<li className="ol__li mb-4">
									<b>Buy &amp; Sell</b>
									<ol className="u-para--readable ol--nostyle">
										<li className="ol__li mb-4">
											User can place buy and sell order by
											specifying the volume and price.
										</li>
										<li className="ol__li mb-4">
											Confirmation box will be displayed
											before placing the order. Upon
											clicking on submit, order will be
											placed in open order
										</li>
									</ol>
								</li>
							</ol>
						</li>
						<li className="ol__li mb-4">
							<h3 className="text-lg font-bold m-0">
								Bank deposit or withdrawal
							</h3>
							<ol className="ol--circleNumbered ol--circleChecked">
								<li className="ol__li mb-4">
									<b>Deposit:</b>
									<ol className="u-para--readable ol--nostyle">
										<li className="ol__li mb-4">
											Once you have completed the
											verification, you will be able to
											add funds to your INR wallet from
											your trading dashboard. Click on
											“Wallet” button. It will take you to
											theaccount page.
										</li>
										<li className="ol__li mb-4">
											On the account page, click on “Add
											Money to Wallet”
										</li>
										<li className="ol__li mb-4">
											Instruction will be given in the
											next page, where you can either
											deposit via P2P or Direct Bank
											deposits through UPI, NEFT, IMPS or
											RTGS.
										</li>
									</ol>
								</li>
								<li className="ol__li mb-4">
									<b>Wihdrawal:</b>
									<ol className="u-para--readable ol--nostyle">
										<li className="ol__li mb-4">
											Withdrawal of INR is easier and
											faster on Bitbns. Just click on the
											“Wallet” button on the dashboard.
											This will take you to account page.
										</li>
										<li className="ol__li mb-4">
											Click on “withdrawal” button below
											“Add Money to Wallet”. Enter the
											amount you want to withdraw.
										</li>
										<li className="ol__li mb-4">
											You will receive your money to the
											bank account mentioned during
											registration.
										</li>
									</ol>
								</li>
							</ol>
						</li>
						<li className="ol__li mb-4">
							<h3 className="text-lg font-bold m-0">
								Cryptocurrencies deposit or withdrawal
							</h3>
							<ol className="ol--circleNumbered ol--circleChecked">
								<li className="ol__li mb-4">
									<b>Deposit:</b>
									<ol className="u-para--readable ol--nostyle">
										<li className="ol__li mb-4">
											After logging into the account,
											click on “Wallet”. This will take
											you to the account page.
										</li>
										<li className="ol__li mb-4">
											Account page will show the
											cryptocurrencies on the left of the
											account page.
										</li>
										<li className="ol__li mb-4">
											You can click on “Deposit” button of
											the relevant cryptocurrency to
											generate the wallet address.
										</li>
										<li className="ol__li mb-4">
											This address can be used to deposit
											that specific cryptocurrency into
											the Bitbns wallet.
										</li>
									</ol>
								</li>
								<li className="ol__li mb-4">
									<b>Wihdrawal:</b>
									<ol className="u-para--readable ol--nostyle">
										<li className="ol__li mb-4">
											After logging into the account,
											click on “Wallet”. This will take
											you to the account page.
										</li>
										<li className="ol__li mb-4">
											Account page will show the
											cryptocurrencies on the left of the
											page.
										</li>
										<li className="ol__li mb-4">
											You can select “withdrawal” button
											of the relevant cryptocurrency.
										</li>
										<li className="ol__li mb-4">
											You will be asked the quantity or
											volume you would like to withdraw
											and the address where you want to
											send the specific cryptocurrency.
										</li>
									</ol>
								</li>
							</ol>
						</li>
					</ol>
				</div>
			</div>
		</div>
		<StartTradingFtr />
		<CoinsList buy price singleLine />
	</>
);

export default HowItWorks;
